import React, { useState } from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  useMediaQuery,
  useTheme,
  Container,
  Paper,
  TextField,
  InputAdornment,
  Stack,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import { Password, PasswordOutlined, Person } from "@mui/icons-material";
import { useLocation, useParams, useNavigate } from "react-router-dom";

// Import the temple image
import templeBackground from "../../assets/scss/templeBackground.jpeg";

// Import CSS

const DurgaTempleLanding = () => {
  // Kiosk-specific styling adjustments
  // Assume kiosk is large screen

  // State for contact input
  const [contactInput, setContactInput] = useState("");
  const [isValid, setIsValid] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const mode = queryParams.get("mode");
  const theme = useTheme();
  const isXSmall = useMediaQuery(theme.breakpoints.down("sm"));
  const isSmall = useMediaQuery(theme.breakpoints.down("md"));
  const isMedium = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const isLarge = useMediaQuery(theme.breakpoints.up("lg"));

  const handleContactChange = (e) => {
    const value = e.target.value;
    setContactInput(value);
    setIsValid(true); // Reset validation state while typing
    setErrorMessage("");
  };

  return (
    <Grid container style={{ height: "100vh" }}>
      <Grid
        item
        xs={12}
        md={6}
        style={{
          backgroundImage: `url(${templeBackground})`,
          imagefit: "cover",
          resizeMode: "fit",
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "30vh",
        }}
      />
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          padding: "40px",
          backgroundColor: "#fdf3e4",
        }}
      >
        {/* Updated Typography for "Welcome" with serif font and orange color */}
        <Box sx={{ height: "50vh", width: "100%" }}>
          <Typography
            variant={isXSmall ? "h5" : isSmall ? "h4" : "h3"}
            component="h2"
            sx={{
              color: "#333",
              marginBottom: "15px",
            }}
          >
            Welcome to <br />
            <span
              style={{
                fontWeight: "bold",
                color: "#970a38",
                background: "linear-gradient(to right, #970a38, orange)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Durga temple of Virginia
            </span>
          </Typography>

          {mode == "kiosk" ? (
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Email or Mobile Number"
              value={contactInput}
              onChange={handleContactChange}
              error={!isValid}
              helperText={errorMessage}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    {contactInput.includes("@") ? <EmailIcon /> : <PhoneIcon />}
                  </InputAdornment>
                ),
                sx: {
                  borderRadius: 1,
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: isValid ? "#7d1128" : "error.main",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: isValid ? "#7d1128" : "error.main",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: isValid ? "#7d1128" : "error.main",
                  },
                },
              }}
              sx={{
                mt: 1,
              }}
            />
          ) : (
            <Stack spacing={2} direction="column" sx={{ width: "100%" }}>
              {" "}
              <TextField
                fullWidth
                variant="outlined"
                placeholder="Email or Mobile Number"
                value={contactInput}
                onChange={handleContactChange}
                error={!isValid}
                helperText={errorMessage}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Person />
                    </InputAdornment>
                  ),
                  sx: {
                    borderRadius: 1,
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: isValid ? "#7d1128" : "error.main",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: isValid ? "#7d1128" : "error.main",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: isValid ? "#7d1128" : "error.main",
                    },
                  },
                }}
              />
              <TextField
                fullWidth
                variant="outlined"
                placeholder="Email or Mobile Number"
                value={contactInput}
                onChange={handleContactChange}
                error={!isValid}
                helperText={errorMessage}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PasswordOutlined />
                    </InputAdornment>
                  ),
                  sx: {
                    borderRadius: 1,
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: isValid ? "#7d1128" : "error.main",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: isValid ? "#7d1128" : "error.main",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: isValid ? "#7d1128" : "error.main",
                    },
                  },
                }}
              />
            </Stack>
          )}

          <Stack spacing={2} direction="column" sx={{ width: "100%", mt: 3 }}>
            <Button
              variant="contained"
              fullWidth
              marginBottom="10px"
              size="large"
              onClick={() => {
                navigate("/poshome");
              }}
            >
              Next
            </Button>
            {mode == "kiosk" && (
              <Button size="large" variant="contained" fullWidth>
                Express Donation
              </Button>
            )}
          </Stack>
        </Box>
      </Grid>
    </Grid>
  );
};

export default DurgaTempleLanding;
